import { axiosInstance as axios } from "./axiosInstance";

export const requestPartPaymentWidgetApi = ({ apiConfigs, channelId }) => {
  const { skbvApiBaseUrl } = apiConfigs;

  return axios({
    method: "get",
    url: `${skbvApiBaseUrl}/Payment/PartPaymentProviderWidget?channelId=${channelId}`,
  })
    .then((response) => {
      if (response.data === null) {
        console.error(
          `response.data is null for response: ${JSON.stringify(response)}`
        );
        return null;
      }

      return response;
    })
    .catch((error) => {
      if (error.response) {
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
      } else if (error.request) {
        console.error(error.request);
      } else {
        console.error("Error", error.message);
      }
      console.error(error.config);
    });
};
